import NavigationCard, { BaseImage } from '../../../navigation/NavigationCard';
import { InternalNavigation } from '../../../navigation/helper';
import React from 'react';
import {
  CustomListsNavigationCard,
  QueryTemplatesNavigationCard,
  SegmentsNavigationCard,
} from './CommonNavigationCards';
import {
  CAN_MODIFY_SCREENING_STATUSES,
  CAN_READ_ALERT_NOTE_TEMPLATE,
  CAN_READ_BATCH,
  CAN_READ_CUSTOM_LIST,
  CAN_READ_DECISION_RULES,
  CAN_READ_ENTITY_GROUP,
  CAN_READ_QUERY_TEMPLATE,
  CAN_VIEW_ATTRIBUTE_MAPPING_MENU,
  CAN_VIEW_SCHEMA_MENU,
} from '../../../auth/permissions';
import Has from '../../../auth/Has';
import {
  faCheckDouble,
  faDatabase,
  faFileImport,
  faShieldCheck,
  faStickyNote,
  faSwapArrows,
} from '@fortawesome/pro-duotone-svg-icons';

const General = () => {
  return (
    <>
      <Has anyPermissions={[CAN_READ_BATCH, CAN_VIEW_SCHEMA_MENU, CAN_VIEW_ATTRIBUTE_MAPPING_MENU]}>
        <h1 className={'m-b-8'}>Data Management</h1>
        <div style={{ display: 'flex', gap: '32px' }}>
          <Has allPermissions={CAN_READ_BATCH}>
            <NavigationCard
              title={'Data Upload'}
              description={'Upload .csv files to add Person data, Transaction data, and Custom List records.'}
              to={InternalNavigation.dataUpload}
              image={{
                base: BaseImage.base1,
                icon: faFileImport,
                iconStyle: {
                  marginLeft: '24px',
                },
              }}
            />
          </Has>
          <Has allPermissions={CAN_VIEW_SCHEMA_MENU}>
            <NavigationCard
              title={'Schemas'}
              description={'Manage Person and Transaction Schemas, essential for data usage across all products.'}
              to={InternalNavigation.schemas}
              image={{
                base: BaseImage.base1,
                icon: faDatabase,
              }}
            />
          </Has>
          <Has allPermissions={CAN_VIEW_ATTRIBUTE_MAPPING_MENU}>
            <NavigationCard
              title={'Mappings'}
              description={'Manage attribute mappings.'}
              to={InternalNavigation.mappings}
              image={{
                base: BaseImage.base1,
                icon: faSwapArrows,
              }}
            />
          </Has>
        </div>
      </Has>
      <Has anyPermissions={[CAN_READ_ENTITY_GROUP, CAN_READ_CUSTOM_LIST, CAN_READ_QUERY_TEMPLATE]}>
        <h1 className={'m-b-8 m-t-32'}>Configuration Resources</h1>
        <div style={{ display: 'flex', gap: '32px' }}>
          <SegmentsNavigationCard />
          <CustomListsNavigationCard />
          <QueryTemplatesNavigationCard base={BaseImage.base2} />
        </div>
      </Has>
      <Has anyPermissions={[CAN_MODIFY_SCREENING_STATUSES, CAN_READ_DECISION_RULES, CAN_READ_ALERT_NOTE_TEMPLATE]}>
        <h1 className={'m-b-8 m-t-32'}>Workflow Management</h1>
        <div style={{ display: 'flex', gap: '32px' }}>
          <Has allPermissions={CAN_MODIFY_SCREENING_STATUSES}>
            <NavigationCard
              title={'Alert Statuses'}
              description={'Create and edit Alert Statuses and Quick Status Notes.'}
              to={InternalNavigation.alertStatuses}
              image={{
                base: BaseImage.base3,
                icon: faShieldCheck,
              }}
            />
          </Has>
          <Has allPermissions={CAN_READ_DECISION_RULES}>
            <NavigationCard
              title={'Decision Rules'}
              description={'View Decision Rules for PERSON and TRANSACTION webhook triggers.'}
              to={InternalNavigation.decisionRules}
              image={{
                base: BaseImage.base3,
                icon: faCheckDouble,
              }}
            />
          </Has>
          <Has allPermissions={CAN_READ_ALERT_NOTE_TEMPLATE}>
            <NavigationCard
              title={'Alert Note Templates'}
              description={
                'Create and manage templates for alert notes to standardize documentation across different alert types.'
              }
              to={InternalNavigation.alertNoteTemplates}
              image={{
                base: BaseImage.base3,
                icon: faStickyNote,
              }}
            />
          </Has>
        </div>
      </Has>
    </>
  );
};

export default General;
